import { useMemo } from "react";
import { useIntl } from "react-intl";
import commonMessages from "../../../common/messages";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const translations = useMemo(() => {
    return {
      defaultError: formatMessage(commonMessages.defaultError),
      selectOfferings: formatMessage(messages.selectOfferings),
      depositAmountError: formatMessage(messages.depositAmountError),
    };
  }, [formatMessage]);

  return translations;
};

export default useTranslations;
